import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/images/logo.png';
const _hoisted_1 = { class: "footer-section" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "footer-area pt-4" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-xl-12" };
const _hoisted_6 = { class: "footer-top d-flex align-items-center justify-content-between" };
const _hoisted_7 = { class: "footer-box" };
const _hoisted_8 = { class: "footer-link d-flex align-items-center gap-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_router_link, {
                                to: "/",
                                class: "d-flex"
                            }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createElementVNode("img", {
                                        src: _imports_0,
                                        class: "logo",
                                        alt: "logo"
                                    }, null, -1)
                                ])),
                                _: 1
                            }),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("ul", _hoisted_8, [
                                    _createElementVNode("li", null, [
                                        _createVNode(_component_router_link, { to: "/about-us" }, {
                                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                _createTextVNode(" About Us ")
                                            ])),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("li", null, [
                                        _createVNode(_component_router_link, { to: "/contact" }, {
                                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                _createTextVNode(" Contact ")
                                            ])),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("li", null, [
                                        _createVNode(_component_router_link, { to: "/privacy-policy" }, {
                                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                _createTextVNode(" Privacy Policy ")
                                            ])),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("li", null, [
                                        _createVNode(_component_router_link, { to: "/terms-of-service" }, {
                                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                _createTextVNode(" Terms of Service ")
                                            ])),
                                            _: 1
                                        })
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "footer-bottom" }, [
                    _createElementVNode("div", { class: "row justify-content-center align-items-center" }, [
                        _createElementVNode("div", { class: "col-lg-7 d-flex justify-content-center justify-content-lg-center order-lg-0 order-1" }, [
                            _createElementVNode("div", { class: "copyright text-center" }, [
                                _createElementVNode("p", null, "© Betrider 2025. All rights reserved.")
                            ])
                        ])
                    ])
                ], -1))
            ])
        ])
    ]));
}
